import './Posting.scss'
import {Progress} from 'antd';
import {FileOutlined} from '@ant-design/icons';
import _ from 'lodash';
import {gql, useQuery} from '@apollo/client';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import cn from 'classnames';

import {posting_info} from '../../routes';

import cls from '../../styles/list.module.scss';

const RECIEVERS = gql`
    query receivers($filters: ReceiverFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
        receivers(filters: $filters, pagination: $pagination, sort: $sort) {
            data {
                id
                attributes {
                    status
                }
            }
        }
    }
`

export const PostRow = ({data}) => {
    const navigate = useNavigate();
    const [successReceivers, setSuccessReceivers] = useState(0);
    const [totalReceivers, setTotalReceivers] = useState(0);

    useQuery(RECIEVERS, {
        variables: {
            filters: {
                postingUid: {eq: data.attributes.uid},
            },
            pagination: {
                limit: 1000,
            },
        },
        onCompleted: (data) => {
            const total = data.receivers.data.length
            setTotalReceivers(total)

            const completedCount = _(data.receivers.data).filter((receivers) => {
                return receivers.attributes.status === 'done'
            }).value()
            setSuccessReceivers(completedCount.length)
        },
        pollInterval: 1000,
    })

    const percentOfSuccess = successReceivers / totalReceivers * 100

    let strokeColor = '#B2F900'
    if (percentOfSuccess < 60) {
        strokeColor = '#F6C546'
    }

    const fileName = data.attributes.media?.data?.attributes?.name
        || data.attributes.mediaUrl?.split('/').pop()

    return (
        <div className={cn([cls.row, 'postRow'])} onClick={() => navigate(posting_info(data.id))}>
            <span className={'postId'}>
                {data.id}
            </span>
            <span className={'postPreview'}>
                {data.attributes.message || (fileName && <><FileOutlined/> {fileName}</>)}
            </span>
            <Progress percent={percentOfSuccess} strokeColor={strokeColor} showInfo={false} className={'postProgress'} />
            <span className={'postTotal'}>
                {successReceivers}/{totalReceivers}
            </span>
        </div>
    );
};



